export default "__VITE_ASSET__ba6f80f7__"